import type { History } from "history";
import { createBrowserHistory } from "history";
import type { FC, ReactNode } from "react";
import { useEffect } from "react";

import { HistoryProvider } from "@shared/context";
import type { BrowserRouterProps } from "@shared/react-router-dom";
import { unstable_HistoryRouter as Router } from "@shared/react-router-dom";

interface Props extends BrowserRouterProps {
  history?: History;
  children: ReactNode;
}

const BrowserRouter: FC<Props> = ({ children, history, ...props }) => {
  history ||= createBrowserHistory(props);

  useEffect(() => {
    const unlisten = history.listen(({ location }) => {
      if (typeof window.ga === "function") {
        window.ga("set", "page", location.pathname + location.search);
        window.ga("send", "pageview");
      }

      window.dataLayer?.push({ event: "pageview" });
    });

    return () => unlisten();
  }, []);

  return (
    <Router {...{ ...props, history }}>
      <HistoryProvider history={history}>{children}</HistoryProvider>
    </Router>
  );
};

export { BrowserRouter };
